import i18n from "components/i18n/i18n";
import * as Handlebars from "handlebars";

export default function(options: any) {
    let result;
    result = i18n.instance.t(options.key, options);
    if (result != null && result.length > 0) {
        result =  result.charAt(0).toUpperCase() + result.slice(1);
    }
    return new Handlebars.SafeString(result);
}
